import { getRequest, postRequest, deleteRequest } from './api'
import { API_URL_WORKORDER } from '../constants/index'

export async function list(size, index, containsValues, orderByValues) {
  const url = new URL(`${API_URL_WORKORDER}protocolAssignment`)

  const queryString = url.search

  const searchParams = new URLSearchParams(queryString)

  if (size !== null && size !== undefined) {
    searchParams.append('size', parseInt(size, 10) || 1000)
  }

  if (index !== null && index !== undefined) {
    searchParams.append('index', parseInt(index, 10) || 0)
  }

  if (containsValues !== null && containsValues !== undefined) {
    searchParams.append('containsValues', containsValues)
  }

  if (orderByValues !== null && orderByValues !== undefined) {
    searchParams.append('orderByValues', orderByValues)
  }

  url.search = searchParams.toString()

  const newUrl = url.toString()

  return getRequest(newUrl)
}

export async function find(id) {
  return getRequest(`${API_URL_WORKORDER}protocolAssignment/${id}`)
}

export async function save(values) {
  return postRequest(`${API_URL_WORKORDER}protocolAssignment`, values)
}

export function remove(id) {
  return deleteRequest(`${API_URL_WORKORDER}protocolAssignment/${id}`)
}
